/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.blueprint.customer.object.type.rpc.CustomerObjectTypeRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  Derived,
  HubspotMetadata,
} from 'rpc-client-utils';

export type EnabledAndDisabledObjectTypeDefinitions = {
  enabledObjectTypeDefinitions: Default<InboundDbObjectType[]>;
  disabledObjectTypeDefinitions: Default<InboundDbObjectType[]>;
};

export type EnabledAndDisabledObjectTypeDefinitionsRequest = {
  includeDeleted: Default<boolean>;
  bypassTranslations: Default<boolean>;
  explicitLocale?: Locale;
};

export type EnabledObjectTypeDefinitions = {
  enabledObjectTypeDefinitions: Default<InboundDbObjectType[]>;
};

export type EnabledObjectTypeDefinitionsRequest = {
  includeDeleted: Default<boolean>;
  bypassTranslations: Default<boolean>;
  explicitLocale?: Locale;
};

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type InboundDbObjectType = {
  id: number;
  objectTypeIdString: Derived<string>;
  objectTypeId: Derived<string>;
  name: string;
  metaType: MetaType;
  metaTypeId: Default<number>;
  hasCustomProperties: Default<boolean>;
  hasDefaultProperties: Default<boolean>;
  hasPipelines: Default<boolean>;
  hasOwners: Default<boolean>;
  hasExternalObjectIds: Default<boolean>;
  allowsSensitiveProperties: Default<boolean>;
  restorable: Default<boolean>;
  deleted: Default<boolean>;
  indexedForFiltersAndReports: Default<boolean>;
  defaultSearchPropertyNames: Default<string[]>;
  requiredProperties: Default<string[]>;
  primaryDisplayLabelPropertyName?: string;
  secondaryDisplayLabelPropertyNames: Default<string[]>;
  createDatePropertyName: Default<string>;
  lastModifiedPropertyName: Default<string>;
  pipelinePropertyName: Default<string>;
  pipelineStagePropertyName: Default<string>;
  pipelineCloseDatePropertyName?: string;
  pipelineTimeToClosePropertyName?: string;
  integrationAppId?: number;
  ownerPortalId?: number;
  singularForm?: string;
  pluralForm?: string;
  readScopeName?: string;
  writeScopeName?: string;
  accessScopeName?: string;
  janusGroup?: string;
  description?: string;
  permissioningType: Default<PermissioningType>;
  scopeMappings: Default<ScopeMapping[]>;
  visibility?: Visibility;
  visibilities: Default<Visibility[]>;
  status?: Status;
  createdAt?: number;
  fullyQualifiedName: Derived<string>;
};

export type MetaType =
  | 'HUBSPOT'
  | 'INTEGRATION'
  | 'PORTAL_SPECIFIC'
  | 'CMS_HUBDB'
  | 'HUBSPOT_EVENT'
  | 'INTEGRATION_EVENT'
  | 'PORTAL_SPECIFIC_EVENT'
  | 'WORK'
  | 'WORK_SUB'
  | unhandledEnumCase;

export type Status =
  | 'LIVE'
  | 'IN_DEVELOPMENT'
  | 'DEPRECATED'
  | unhandledEnumCase;

export type Visibility =
  | 'CUSTOMER_FACING'
  | 'INTERNAL_ONLY'
  | 'CUSTOMER_FACING_UI'
  | 'CUSTOMER_FACING_PUBLIC_API'
  | unhandledEnumCase;

export type AccessLevel =
  | 'OWNED'
  | 'TEAM_OWNED'
  | 'UNASSIGNED'
  | 'ALL'
  | unhandledEnumCase;

export type PermissioningType =
  | 'DO_NOT_CHECK_PERMISSIONS'
  | 'ALL_OR_NONE'
  | 'OWNER_BASED'
  | 'TEAM_BASED'
  | 'EXPLICIT'
  | unhandledEnumCase;

export type RequestAction =
  | 'COMMUNICATE'
  | 'EDIT'
  | 'VIEW'
  | 'DELETE'
  | 'MERGE'
  | 'EDIT_ASSOCIATION'
  | 'VIEW_SCHEMA'
  | 'EDIT_SCHEMA'
  | 'DELETE_SCHEMA'
  | unhandledEnumCase;

export type ScopeMapping = {
  requestAction: RequestAction;
  accessLevel: AccessLevel;
  scopeName: string;
};

export type Locale =
  | 'EN'
  | 'FR'
  | 'DE'
  | 'JA'
  | 'ES'
  | 'PT_BR'
  | 'NL'
  | 'BN'
  | 'CS'
  | 'DA_DK'
  | 'EL_GR'
  | 'ES_MX'
  | 'FI'
  | 'HR'
  | 'HU'
  | 'ID'
  | 'IT'
  | 'KO_KR'
  | 'NO'
  | 'PL'
  | 'RO'
  | 'RU'
  | 'SV'
  | 'TH'
  | 'VI_VN'
  | 'ZH_CN'
  | 'ZH_HK'
  | 'AF_ZA'
  | 'AR_EG'
  | 'BG'
  | 'CA_ES'
  | 'SL'
  | 'TR'
  | 'UK'
  | 'EN_GB'
  | 'FR_CA'
  | 'HE_IL'
  | 'LT_LT'
  | 'PT_PT'
  | 'SK_SK'
  | 'MS'
  | 'TL'
  | 'ZH_TW'
  | 'HI_IN'
  | 'ET_EE'
  | unhandledEnumCase;

export type GetAllEnabledObjectTypeDefinitionsForPortalRequestType =
  Requestify<EnabledObjectTypeDefinitionsRequest>;
export type GetAllEnabledObjectTypeDefinitionsForPortalResponseType =
  EnabledObjectTypeDefinitions;
export type GetAllEnabledObjectTypeDefinitionsForPortalErrorType = EmptyError &
  HubspotMetadata;
export const getAllEnabledObjectTypeDefinitionsForPortalRpc: ChirpAvroRpcDetails<
  GetAllEnabledObjectTypeDefinitionsForPortalRequestType,
  GetAllEnabledObjectTypeDefinitionsForPortalResponseType,
  GetAllEnabledObjectTypeDefinitionsForPortalErrorType,
  false
> = {
  serviceName:
    'com.hubspot.blueprint.customer.object.type.rpc.CustomerObjectTypeRpc',
  rpcName: 'getAllEnabledObjectTypeDefinitionsForPortal',
  auth: 'app',
  fingerprint: 'ERCeKWk3ES17BCaRR1jHaJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAllEnabledAndDisabledObjectTypeDefinitionsForPortalSortedRequestType =
  Requestify<EnabledAndDisabledObjectTypeDefinitionsRequest>;
export type GetAllEnabledAndDisabledObjectTypeDefinitionsForPortalSortedResponseType =
  EnabledAndDisabledObjectTypeDefinitions;
export type GetAllEnabledAndDisabledObjectTypeDefinitionsForPortalSortedErrorType =
  EmptyError & HubspotMetadata;
export const getAllEnabledAndDisabledObjectTypeDefinitionsForPortalSortedRpc: ChirpAvroRpcDetails<
  GetAllEnabledAndDisabledObjectTypeDefinitionsForPortalSortedRequestType,
  GetAllEnabledAndDisabledObjectTypeDefinitionsForPortalSortedResponseType,
  GetAllEnabledAndDisabledObjectTypeDefinitionsForPortalSortedErrorType,
  false
> = {
  serviceName:
    'com.hubspot.blueprint.customer.object.type.rpc.CustomerObjectTypeRpc',
  rpcName: 'getAllEnabledAndDisabledObjectTypeDefinitionsForPortalSorted',
  auth: 'app',
  fingerprint: 'wgUCAVeh15vgWvb1QhvIr5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAllScopeAccessibleEnabledAndDisabledObjectTypeDefinitionsForPortalSortedRequestType =
  Requestify<EnabledAndDisabledObjectTypeDefinitionsRequest>;
export type GetAllScopeAccessibleEnabledAndDisabledObjectTypeDefinitionsForPortalSortedResponseType =
  EnabledAndDisabledObjectTypeDefinitions;
export type GetAllScopeAccessibleEnabledAndDisabledObjectTypeDefinitionsForPortalSortedErrorType =
  EmptyError & HubspotMetadata;
export const getAllScopeAccessibleEnabledAndDisabledObjectTypeDefinitionsForPortalSortedRpc: ChirpAvroRpcDetails<
  GetAllScopeAccessibleEnabledAndDisabledObjectTypeDefinitionsForPortalSortedRequestType,
  GetAllScopeAccessibleEnabledAndDisabledObjectTypeDefinitionsForPortalSortedResponseType,
  GetAllScopeAccessibleEnabledAndDisabledObjectTypeDefinitionsForPortalSortedErrorType,
  false
> = {
  serviceName:
    'com.hubspot.blueprint.customer.object.type.rpc.CustomerObjectTypeRpc',
  rpcName:
    'getAllScopeAccessibleEnabledAndDisabledObjectTypeDefinitionsForPortalSorted',
  auth: 'app',
  fingerprint: 'wgUCAVeh15vgWvb1QhvIr5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
